<template>
	<div class="dropdown dropright border-bottom-item">
		<button class="dropdown-item" v-on:click="viewAirway()" type="button">
			Airway View
		</button>
	</div>
</template>

<script>

import { enterAirwayMode } from "./AirwayMode";

export default {
	name: "AirwayMenu",
	props: ["isEngineerMode"],
	components: {},
	methods: {
		viewAirway: function () {
			gtag('event', 'View->Airway View');
			enterAirwayMode();
		}
	}
};


</script>

<style scoped></style>